export const LAYOUT_ADMIN_HOME = `/app/home`

export const LAYOUT_ADMIN_PANEL = `/app/admin/panel`

export const LAYOUT_ADMIN_BOX_VIEW = (id) => `/app/admin/box/view/${id}`
export const LAYOUT_ADMIN_BOX_BROWSE = "/app/admin/box/browse"

export const LAYOUT_ADMIN_FILE_MANAGER_ROOT = `/app/admin/file-manager`
export const LAYOUT_ADMIN_FILE_MANAGER_VIEW = (id) => `/app/admin/file-manager/view/${id}`
export const LAYOUT_ADMIN_FILE_MANAGER_BROWSE = "/app/admin/file-manager/browse"

export const LAYOUT_ADMIN_MANAGER_ROOT = `/app/admin/manager`
export const LAYOUT_ADMIN_MANAGER_LIST = `/app/admin/manager/list`
export const LAYOUT_ADMIN_MANAGER_NEW = `/app/admin/manager/new`
export const LAYOUT_ADMIN_MANAGER_EDIT = (id) => `/app/admin/manager/edit/${id}`

export const LAYOUT_ADMIN_SERVICE_ROOT = `/app/admin/service`
export const LAYOUT_ADMIN_SERVICE_LIST = `/app/admin/service/list`
export const LAYOUT_ADMIN_SERVICE_NEW = `/app/admin/service/new`
export const LAYOUT_ADMIN_SERVICE_EDIT = (id) => `/app/admin/service/edit/${id}`
export const LAYOUT_ADMIN_SERVICE_SHOW = (id) => `/app/admin/service/show/${id}`

export const LAYOUT_ADMIN_UNIT_ROOT = `/app/admin/unit`
export const LAYOUT_ADMIN_UNIT_LIST = `/app/admin/unit/list`
export const LAYOUT_ADMIN_UNIT_NEW = `/app/admin/unit/new`
export const LAYOUT_ADMIN_UNIT_EDIT = (id) => `/app/admin/unit/edit/${id}`

export const LAYOUT_ADMIN_LANGUAGE_PAIR_ROOT = `/app/admin/language-pair`
export const LAYOUT_ADMIN_LANGUAGE_PAIR_LIST = `/app/admin/language-pair/list`
export const LAYOUT_ADMIN_LANGUAGE_PAIR_NEW = `/app/admin/language-pair/new`
export const LAYOUT_ADMIN_LANGUAGE_PAIR_EDIT = (id) => `/app/admin/language-pair/edit/${id}`

export const LAYOUT_ADMIN_LANGUAGE_ROOT = `/app/admin/language`
export const LAYOUT_ADMIN_LANGUAGE_LIST = `/app/admin/language/list`

export const LAYOUT_ADMIN_COUNTRY_ROOT = `/app/admin/country`
export const LAYOUT_ADMIN_COUNTRY_LIST = `/app/admin/country/list`

export const LAYOUT_ADMIN_USER_ROOT = `/app/admin/user`
export const LAYOUT_ADMIN_USER_LIST = `/app/admin/user/list`

export const LAYOUT_ADMIN_CAMPAIGN_ROOT = `/app/admin/campaign`
export const LAYOUT_ADMIN_CAMPAIGN_LIST = `/app/admin/campaign/list`
export const LAYOUT_ADMIN_CAMPAIGN_NEW = `/app/admin/campaign/new`
export const LAYOUT_ADMIN_CAMPAIGN_EDIT = (id) => `/app/admin/campaign/edit/${id}`

export const LAYOUT_ADMIN_TEMPLATE_ROOT = `/app/admin/template`
export const LAYOUT_ADMIN_TEMPLATE_LIST = `/app/admin/template/list`
export const LAYOUT_ADMIN_TEMPLATE_EDIT = (id) => `/app/admin/template/edit/${id}`

export const LAYOUT_ADMIN_NOTIFICATION_GROUP_ROOT = `/app/admin/notification-group`
export const LAYOUT_ADMIN_NOTIFICATION_GROUP_LIST = `/app/admin/notification-group/list`
export const LAYOUT_ADMIN_NOTIFICATION_GROUP_EDIT = (id) => `/app/admin/notification-group/edit/${id}`
export const LAYOUT_ADMIN_NOTIFICATION_GROUP_SHOW = (id) => `/app/admin/notification-group/show/${id}`

export const LAYOUT_ADMIN_SPECIALIZATION_ROOT = `/app/admin/specialization`
export const LAYOUT_ADMIN_SPECIALIZATION_LIST = `/app/admin/specialization/list`
export const LAYOUT_ADMIN_SPECIALIZATION_NEW = `/app/admin/specialization/new`
export const LAYOUT_ADMIN_SPECIALIZATION_EDIT = (id) => `/app/admin/specialization/edit/${id}`

export const LAYOUT_ADMIN_TAG_ROOT = `/app/admin/tag`
export const LAYOUT_ADMIN_TAG_LIST = `/app/admin/tag/list`
export const LAYOUT_ADMIN_TAG_NEW = `/app/admin/tag/new`
export const LAYOUT_ADMIN_TAG_EDIT = (id) => `/app/admin/tag/edit/${id}`

export const LAYOUT_ADMIN_PRIORITY_ROOT = `/app/admin/priority`
export const LAYOUT_ADMIN_PRIORITY_LIST = `/app/admin/priority/list`
export const LAYOUT_ADMIN_PRIORITY_NEW = `/app/admin/priority/new`
export const LAYOUT_ADMIN_PRIORITY_EDIT = (id) => `/app/admin/priority/edit/${id}`

export const LAYOUT_ADMIN_BRAND_ROOT = `/app/admin/brand`
export const LAYOUT_ADMIN_BRAND_FORM = `/app/admin/brand/form`

export const LAYOUT_ADMIN_THEME_ROOT = `/app/admin/theme`
export const LAYOUT_ADMIN_THEME_FORM = `/app/admin/theme/form`

export const LAYOUT_ADMIN_EMAIL_ROOT = `/app/admin/email`
export const LAYOUT_ADMIN_EMAIL_FORM = `/app/admin/email/form`

export const LAYOUT_ADMIN_CONFIG_ROOT = "/app/admin/config"
export const LAYOUT_ADMIN_CONFIG_SETTING = "/app/admin/config/setting"
export const LAYOUT_ADMIN_CONFIG_MIGRATION = "/app/admin/config/migration"
export const LAYOUT_ADMIN_CONFIG_INFORMATION = "/app/admin/config/information"

export const LAYOUT_ADMIN_CONFIG_SETTING_FORM = "/app/admin/config/setting/update"

export const LAYOUT_ADMIN_MAIL_QUEUE_ROOT = `/app/admin/mail-queue`
export const LAYOUT_ADMIN_MAIL_QUEUE_LIST = `/app/admin/mail-queue/list`

export const LAYOUT_ADMIN_SMTP_ROOT = `/app/admin/smtp`
export const LAYOUT_ADMIN_SMTP_FORM = `/app/admin/smtp/form`

export const LAYOUT_ADMIN_STORAGE_ROOT = `/app/admin/storage`
export const LAYOUT_ADMIN_STORAGE_FORM = `/app/admin/storage/form`
export const LAYOUT_ADMIN_STORAGE_LIST = `/app/admin/storage/list`

export const LAYOUT_ADMIN_WORKING_HOURS_ROOT = `/app/admin/working-hours`
export const LAYOUT_ADMIN_WORKING_HOURS_FORM = `/app/admin/working-hours/form`

export const LAYOUT_ADMIN_TEMPLATE_FOLDER_ROOT = `/app/admin/template-folder`
export const LAYOUT_ADMIN_TEMPLATE_FOLDER_LIST = `/app/admin/template-folder/list`
export const LAYOUT_ADMIN_TEMPLATE_FOLDER_NEW = `/app/admin/template-folder/new`
export const LAYOUT_ADMIN_TEMPLATE_FOLDER_EDIT = (id) => `/app/admin/template-folder/edit/${id}`
